module.exports = __webpack_public_path__ + "static/media/liveroom-setting-schdule.fb187427.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-schdule.png
// module id = 1976
// module chunks = 6